// extracted by mini-css-extract-plugin
module.exports = {"textInput":"ItemCreateDialog_textInput__20-hc","creatorRoot":"ItemCreateDialog_creatorRoot__n65ik"};